import { render, staticRenderFns } from "./package-status.vue?vue&type=template&id=66efd161&scoped=true"
import script from "./package-status.vue?vue&type=script&setup=true&lang=js"
export * from "./package-status.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66efd161",
  null
  
)

export default component.exports